import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import { SortableElement } from 'react-sortable-hoc';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from '../../styles.module.css';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
const BlankRow = SortableElement(() => <div className={styles.blankRow} data-role="header" />);

export default BlankRow;
